import script from "./whoWeAre.vue?vue&type=script&setup=true&lang=js"
export * from "./whoWeAre.vue?vue&type=script&setup=true&lang=js"

import "./whoWeAre.vue?vue&type=style&index=0&id=53f2fb4b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53f2fb4b"]])

export default __exports__